import React from 'react';
import {MasterLayout} from 'components/layouts';
import {ProfileContainer} from 'components/users';
import MemberZone from './MemberZone.jsx';
import title from 'constants/TitlePages.js';

class Profile extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.Profile;
  }

  render() {
    return (
      <MasterLayout isActive='profile'>
        <ProfileContainer/>
      </MasterLayout>
    );
  }
}

export default MemberZone(Profile);



// WEBPACK FOOTER //
// ./pages/users/Profile.jsx